import { render } from "./ColumnComponent.vue?vue&type=template&id=6becce74"
import script from "./ColumnComponent.vue?vue&type=script&lang=js"
export * from "./ColumnComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__